module.exports = __webpack_public_path__ + "static/PatKT-08-747e5acae51468300a31a0958ba897a4.jpg";